<template>
	<el-dialog
		title="修改角色"
		width="550px"
		v-model="data.dialogTableVisible"
		@close="handleReset"
	>
		<el-form label-width="90px">
			<el-form-item label="角色">
				<el-select
					style="width: 100%"
					v-model="data.formLabelAlign.role"
					placeholder="请选择角色"
					@change="handleRoleChange"
				>
					<el-option
						v-for="item in roleList"
						:key="item.id"
						:label="item.roleName"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="菜单权限">
				<el-checkbox-group v-model="data.formLabelAlign.menuAuth">
					<el-checkbox
						v-for="(item, index) in data.menuItemList"
						:key="index"
						:label="item.id"
					>
						{{ item.menuName }}</el-checkbox
					>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item label="备注">
				<el-input
					v-model="data.formLabelAlign.remark"
					placeholder="请输入备注"
					type="textarea"
					:autosize="{ minRows: 2, maxRows: 4 }"
				></el-input>
			</el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button @click="handleCancle">取消</el-button>
			<el-button type="primary" @click="handleSave">确定</el-button>
		</footer>
	</el-dialog>
</template>

<script>
import { computed, inject, onMounted, reactive, ref } from "vue";
import {
	apiMenuList,
	apiRoleMenuList,
	apiRoleMenuUpdate,
} from "@/api/requestApis.js";
export default {
	props: {
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup() {
		const roleList = inject("roleList");

		const data = reactive({
			menuItemList: [],
			dialogTableVisible: false,
			formLabelAlign: {
				menuAuth: [],
				role: "",
				status: true,
				remark: "",
			},
		});
		data.formLabelAlign.role = roleList.value[0].id;

		const handleReset = () => {
			data.formLabelAlign.role = "";
			data.formLabelAlign.status = true;
			data.formLabelAlign.remark = "";
			data.formLabelAlign.menuAuth = [];
		};

		const handleSave = async () => {
			await apiRoleMenuUpdate({
				roleId: data.formLabelAlign.role,
				menuId: data.formLabelAlign.menuAuth.join(),
			});
			handleToggle(false);
			handleReset();
		};

		const handleCancle = () => {
			handleToggle(false);
			handleReset();
		};

		const setMenuAuth = async () => {
			const roleMenu = await apiRoleMenuList();
			const list = roleMenu.records.filter(
				(item) => item.roleId == data.formLabelAlign.role
			);
			data.formLabelAlign.menuAuth = list.map((item) =>
				Number(item.menuId)
			);
		};

		const handleSetDefaultValue = async () => {
			const menuList = await apiMenuList();
			data.menuItemList = menuList.records;
			setMenuAuth();
		};

		const handleRoleChange = (val) => {
			setMenuAuth();
		};

		const handleToggle = (val) => {
			data.dialogTableVisible = val;
			if (val) handleSetDefaultValue();
		};
		return {
			handleRoleChange,
			handleReset,
			roleList,
			handleToggle,
			handleSave,
			handleCancle,
			data,
		};
	},
};
</script>

<style  scoped>
</style>
